import axios from './axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson, headerJson } from '../_helpers/auth-header'

import { config } from '../config'
const base_url = config.apiUrl

const model = 'Class/'

export const classService = {
  getAll,
  getByUnionId,
  getById,
  add,
  edit,
  delete: _delete
}

function getAll(dto) {
  const url = base_url + model + 'GetAll'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByUnionId(unionId) {
  const url = base_url + model + 'getByUnionId/' + unionId
  // console.log(url);

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: headerJson() })
}

function getById(id) {
  const url = base_url + model + 'getById/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(form) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, form, { headers: authHeaderJson() })
}

function edit(form) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, form, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}
